// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56e0abf7","732":"de914f34","977":"2b1720f0"}[chunkId] + ".chunk.js";
};